import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutOtherChargeCompareItem extends Layout {
    sourceEdiCompareItem: DataSource;
    tableCompareItems: Table;
}
